module.exports = __webpack_public_path__ + "components/flag/static/square/bt-19f11bfdd9835efa09e13c5e98bbac59.svg";